import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import NumberToPersianWord from "number_to_persian_word";
import GetPrice from "../Functions/GetPrice";
import authHeader from "../Services/auth-header";
import UserProjects from "../Static Files/UserProjects.json";
import { refreshToken } from "../Services/auth.service";
import { CartUpdatedTrue } from "../Actions/types";
import { useDispatch, useSelector } from "react-redux";
import AddProjectToCart from "../Functions/AddProjectToCart";
import GetUserProjectData from "../Functions/GetUserProjectData";
import Modal from "react-bootstrap/Modal";
import Select from "react-dropdown-select";
import { convertToPersian, NumToFa } from "../Functions/TextTransform";
import { Accordion, AccordionContext, useAccordionButton } from "react-bootstrap";
import { CapitalizeAllWords } from "../Functions/TextTransform";
import GetMeasurementArray from "../Functions/GetMeasurementArray";
import ShowMoreLineLimited from "../Components/ShowMoreLineLimited";
import RenderSideCart from "../Components/RenderSideCart";
import { useMediaQuery } from "react-responsive";
import QTY from "../Components/QTY";
import CustomControlFiles from "../Components/CustomControlFiles";
import {
  baseURLPrice,
  baseURLFreeShipping,
  baseURLGetCart,
  baseURLDeleteFile,
  baseURLDeleteBasketProject,
  baseURLGetProjects,
  baseURLEditProject,
  baseURLDeleteProject,
} from "../Services/client";
import { imgUrl } from "../config/api";

function Projects() {
  const { t } = useTranslation();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { cartUpdated, mainCart, sideCartPrice } = useSelector((state) => state.auth);

  const [firstFetch, setFirstFetch] = useState(true);
  const [userProjects, setUserProjects] = useState([]);
  const [userProjectsRender, setUserProjectsRender] = useState([]);
  const [bagProjectObject, setBagProjectObject] = useState({});

  const [modals, setModals] = useState({});
  const [files, setFiles] = useState({});

  const [show, setShow] = useState(false);
  const zoomModalHeaderRef = useRef([]);
  const [zoomModalBody, setZoomModalBody] = useState([]);

  const [cartStateAgree, setCartStateAgree] = useState(false);
  const [cartAgreeDescription, setCartAgreeDescription] = useState(false);
  const [addingLoading, setAddingLoading] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [sideCartObjects, setSideCartObjects] = useState({});
  const [cartAgree, setCartAgree] = useState([]);
  const [freeShipPrice, setFreeShipPrice] = useState(0);
  const draperyRef = useRef({});

  const projectRef = useRef({});
  const projectsButtonRef = useRef({});

  function ContextAwareToggleViewDetails({
    eventKey,
    callback,
    textOnHide,
    textOnShow,
    textOnHide2,
    textOnShow2,
    type,
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        {type === 2 && (
          <>
            <div className="dropdown_button_container_left">
              <h3 className="dk_curtain_preview_item_details">
                {isCurrentEventKey ? textOnShow2 : textOnHide2}
              </h3>
            </div>
            <div className="dropdown_button_container_right">
              <button
                className="basket_item_title_dropdown_btn"
                aria-expanded={`${isCurrentEventKey}`}
                type="button"
                onClick={decoratedOnClick}
              >
                <h4 className="dk_curtain_preview_item_details">
                  {isCurrentEventKey ? textOnShow : textOnHide}
                </h4>
              </button>
            </div>
          </>
        )}
        {(type === undefined || type === 1) && (
          <button
            className="basket_item_title_dropdown_btn"
            aria-expanded={`${isCurrentEventKey}`}
            type="button"
            onClick={decoratedOnClick}
          >
            <h4 className="dk_curtain_preview_item_details">
              {isCurrentEventKey ? textOnShow : textOnHide}
            </h4>
          </button>
        )}
      </>
    );
  }

  function getUserProjects() {
    axios
      .get(baseURLGetProjects, {
        headers: authHeader(),
      })
      .then((response) => {
        setUserProjects(response.data);
        setFirstFetch(false);
        if (!response.data.length) {
          setUserProjectsRender([
            <h1 key={1} className="no_project">
              You don't have any saved project yet.
            </h1>,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getUserProjects();
            } else {
              navigate("/" + pageLanguage);
              setFirstFetch(false);
              setUserProjectsRender([
                <h1 key={1} className="no_project">
                  You don't have any saved project yet.
                </h1>,
              ]);
            }
          });
        } else {
          setFirstFetch(false);
          setUserProjectsRender([
            <h1 key={1} className="no_project">
              You don't have any saved project yet.
            </h1>,
          ]);
        }
      });
  }

  function renderUserProjects() {
    let projectData = JSON.parse(JSON.stringify(UserProjects));
    let tempDrapery = JSON.parse(JSON.stringify(userProjects));
    let tempFiles = JSON.parse(JSON.stringify(files));
    let tempProjectArr = [];
    let promiseArr = [];
    console.log(`tempDrapery`, tempDrapery);
    tempDrapery
      .sort(function(a, b) {
        return b["CreatedDate"] - a["CreatedDate"] || b["SewingOrderId"] - a["SewingOrderId"];
      })
      .forEach((obj1, i) => {
        console.log(`obj1`, obj1);
        promiseArr[i] = new Promise((resolve, reject) => {
          let obj = obj1["PreorderText"] || {};

          let SewingModelId = obj["SewingModelId"];
          let userProjects = projectData[obj["SewingModelId"]]
            ? projectData[obj["SewingModelId"]]["data"]
            : [];
          let desc = [];
          let temp1 = [];
          let temp2 = [];
          let temp3 = [];
          let temp4 = [];
          let temp5 = [];
          let projectId = obj1["SewingOrderId"];
          let defaultModelNameFa = obj["ModelNameFa"];
          let defaultModelName = obj["ModelNameEn"];
          let roomNameFa = obj["RoomNameFa"];
          let roomName = obj["RoomNameEn"];
          let WindowName = obj["WindowName"] === undefined ? "" : obj["WindowName"];
          let moreInfoInput = obj["moreInfoInput"] === undefined ? "" : obj["moreInfoInput"];
          let photoUrl = obj["PhotoUrl"];
          let zipcode = obj1["ZipCode"];

          let uploadedFiles = obj1["SewingOrderAttachments"];
          let tempSelectArr = [];
          if (uploadedFiles && uploadedFiles.length > 0) {
            let promiseArrFiles = [];
            uploadedFiles.forEach((obj1, index) => {
              promiseArrFiles[index] = new Promise((resolve, reject) => {
                tempSelectArr.push({
                  value: obj1["FileUrl"],
                  label: obj1["UserFileName"],
                });
                resolve();
              });
            });
            Promise.all(promiseArrFiles).then(() => {
              tempFiles[`${projectId}`] = tempSelectArr;
            });
          }

          let promiseArr0 = [];
          let firstMeasurements = true;
          if (SewingModelId === "0099") {
            promiseArr0[0] = new Promise((resolve, reject) => {
              GetUserProjectData(obj1, true)
                .then((cartValues) => {
                  let promiseArr4 = [];
                  if (cartValues["Accessories"] !== undefined) {
                    cartValues["Accessories"].forEach((obj, index) => {
                      if (obj["DesignNameFa"] !== undefined && obj["DesignNameEn"] !== undefined) {
                        promiseArr4[index] = new Promise((resolve, reject) => {
                          if (obj["DesignNameFa"] && obj["DesignNameEn"]) {
                            temp4[index] = (
                              <li className="cart_agree_item" key={"acc" + index}>
                                <h1 className="cart_agree_item_title">
                                  {pageLanguage === "fa"
                                    ? obj["DesignNameFa"]
                                    : obj["DesignNameEn"]}
                                </h1>
                                <h2 className="cart_agree_item_desc">
                                  {t("agree_Qty")}
                                  {NumToFa(obj["Qty"], pageLanguage)}
                                </h2>
                              </li>
                            );
                          }
                          resolve();
                        });
                      }
                    });
                  }

                  let promiseArr3 = [];
                  Object.keys(cartValues).forEach((key, index) => {
                    promiseArr3[index] = new Promise((resolve, reject) => {
                      let tempObj = userProjects.find((obj) => obj["cart"] === key);
                      if (tempObj === undefined || cartValues[key] === undefined) {
                        resolve();
                      } else if (
                        tempObj["measurements"] &&
                        (obj["WindowWidth"] === undefined || obj["WindowHeight"] === undefined)
                      ) {
                        if (
                          obj["Width1"] ||
                          obj["Width2"] ||
                          obj["Width3"] ||
                          obj["Height1"] ||
                          obj["Height2"] ||
                          obj["Height3"] ||
                          obj["LeftWidthExt"] ||
                          obj["RightWidthExt"] ||
                          obj["HeightOfRodMount"] ||
                          obj["HeightOfCeilingToFloor"]
                        ) {
                          let tempObj2 = userProjects.find(
                            (obj) => obj["apiLabel"] === "WindowWidth"
                          );
                          desc[tempObj2["order"]] = (
                            <div className="basket_item_title_desc 1" key={i}>
                              <h3>{t("Measurements")}&nbsp;</h3>
                              <h4>{t("Almost Complete")}</h4>
                            </div>
                          );
                          resolve();
                        } else {
                          resolve();
                        }
                      } else {
                        if (
                          key === "WindowWidth" &&
                          tempObj["measurements"] &&
                          obj["WindowWidth"] &&
                          obj["WindowHeight"]
                        ) {
                          if (firstMeasurements) {
                            firstMeasurements = false;
                            if (obj["CalcWindowSize"]) {
                              desc[tempObj["order"]] = (
                                <div className="basket_item_title_desc 2" key={index}>
                                  <h3>{t("Measurements")}&nbsp;</h3>
                                  <h4 className="basket_measurement_accordion_container">
                                    <Accordion>
                                      <Accordion.Item eventKey="0">
                                        <ContextAwareToggleViewDetails
                                          eventKey="0"
                                          textOnHide={
                                            NumToFa(
                                              obj["WindowWidth"] + t("Measurements CM"),
                                              pageLanguage
                                            ) +
                                            " x " +
                                            NumToFa(
                                              obj["WindowHeight"] + t("Measurements CM"),
                                              pageLanguage
                                            )
                                          }
                                          textOnShow={t("Hide Details")}
                                        />
                                        <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                          <div className="basket_item_title_container">
                                            <GetMeasurementArray
                                              modelId={`${SewingModelId}`}
                                              cartValues={cartValues}
                                            />
                                          </div>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </h4>
                                </div>
                              );
                            } else {
                              desc[tempObj["order"]] = (
                                <div className="basket_item_title_desc 3" key={index}>
                                  <h3>{t("Measurements")}&nbsp;</h3>
                                  <h4>
                                    {NumToFa(
                                      obj["WindowWidth"] + t("Measurements CM"),
                                      pageLanguage
                                    ) +
                                      " x " +
                                      NumToFa(
                                        obj["WindowHeight"] + t("Measurements CM"),
                                        pageLanguage
                                      )}
                                  </h4>
                                </div>
                              );
                              resolve();
                            }
                            resolve();
                          } else {
                            resolve();
                          }
                        } else if (
                          key === "WindowHeight" &&
                          tempObj["measurements"] &&
                          obj["WindowWidth"] &&
                          obj["WindowHeight"]
                        ) {
                          resolve();
                        } else if (
                          (key === "PanelTypeOption" &&
                            cartValues["PanelTypeOption"] === "Customize Style Per Curtain") ||
                          (key === "Hardware" &&
                            cartValues["Hardware"] === "I Want To Customize Hardware Per Curtain")
                        ) {
                          resolve();
                        } else if (
                          tempObj["title"] !== "" &&
                          tempObj["lang"].indexOf(pageLanguage) > -1
                        ) {
                          let objLabel = "";
                          if (key === "ControlType" && cartValues["ControlType"] === "Motorized") {
                            objLabel =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(
                                    `${t(cartValues[key]?.toString())} / ${t(
                                      cartValues["MotorType"]?.toString()
                                    )}`
                                  )?.toString()
                                : `${t(cartValues[key]?.toString())} / ${t(
                                    cartValues["MotorType"]?.toString()
                                  )}`;
                          } else if (
                            key === "DraperyHardware" &&
                            cartValues["DraperyHardware"] !== "None"
                          ) {
                            objLabel =
                              t(cartValues[key]?.toString()) +
                              " / " +
                              (pageLanguage === "fa"
                                ? cartValues["RailDesignFaA"]
                                : cartValues["RailDesignEnA"]) +
                              " \n " +
                              (pageLanguage === "fa"
                                ? cartValues["RailColorFaA"]
                                : cartValues["RailColorEnA"]) +
                              " / " +
                              t(cartValues["BatonOptionA"]);
                          } else if (
                            key === "SheerHardware" &&
                            cartValues["SheerHardware"] !== "None"
                          ) {
                            if (cartValues["RailDesignEnB"] === "Motorized Track") {
                              objLabel =
                                t(cartValues[key]?.toString()) +
                                " / " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailDesignFaB"]
                                  : cartValues["RailDesignEnB"]);
                            } else {
                              objLabel =
                                t(cartValues[key]?.toString()) +
                                " / " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailDesignFaB"]
                                  : cartValues["RailDesignEnB"]) +
                                " \n " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailColorFaB"]
                                  : cartValues["RailColorEnB"]) +
                                " / " +
                                (cartValues["BatonOptionB"]
                                  ? t(cartValues["BatonOptionB"])
                                  : t(cartValues["ControlPositionB"]));
                            }
                          } else if (
                            key === "PrivacyLayerHardware" &&
                            cartValues["PrivacyLayerHardware"] !== "None"
                          ) {
                            if (cartValues["RailDesignEnC"] === "Motorized Track") {
                              objLabel =
                                t(cartValues[key]?.toString()) +
                                " / " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailDesignFaC"]
                                  : cartValues["RailDesignEnC"]);
                            } else {
                              objLabel =
                                t(cartValues[key]?.toString()) +
                                " / " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailDesignFaC"]
                                  : cartValues["RailDesignEnC"]) +
                                " \n " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailColorFaC"]
                                  : cartValues["RailColorEnC"]) +
                                " / " +
                                (cartValues["BatonOptionC"]
                                  ? t(cartValues["BatonOptionC"])
                                  : t(cartValues["ControlPositionC"]));
                            }
                          } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                            objLabel =
                              t("agree_Qty") + NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                          } else if (key === "HandCurtainEn2" || key === "HandCurtainFa2") {
                            objLabel =
                              t("agree_Qty") + NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                          } else if (tempObj["titleValue"] === null || true) {
                            if (tempObj["titlePostfix"] === "") {
                              objLabel =
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(
                                      `${t(cartValues[key]?.toString())}`
                                    )?.toString()
                                  : t(cartValues[key]?.toString());
                            } else {
                              objLabel =
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(
                                      `${cartValues[key]}`
                                    )?.toString() + t(tempObj["titlePostfix"])
                                  : cartValues[key]?.toString() + t(tempObj["titlePostfix"]);
                            }
                          } else {
                            if (tempObj["titleValue"][cartValues[key].toString()] === null) {
                              if (tempObj["titlePostfix"] === "") {
                                objLabel = t(cartValues[key].toString());
                              } else {
                                objLabel =
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(
                                        `${cartValues[key]}`
                                      ).toString() + t(tempObj["titlePostfix"])
                                    : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                              }
                            } else {
                              objLabel = t(tempObj["titleValue"][cartValues[key].toString()]);
                            }
                          }
                          if (tempObj["fabric"] === undefined) {
                            temp5[tempObj["order"]] = (
                              <li className="cart_agree_item" key={key}>
                                <h1 className="cart_agree_item_title">
                                  {t(tempObj["title"])}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">{objLabel}</h2>
                              </li>
                            );
                            resolve();
                          } else if (tempObj["fabric"] === 1) {
                            temp1[tempObj["order"]] = (
                              <li className="cart_agree_item" key={key}>
                                <h1 className="cart_agree_item_title">
                                  {t(tempObj["title"])}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">{objLabel}</h2>
                              </li>
                            );
                            resolve();
                          } else if (tempObj["fabric"] === 2) {
                            temp2[tempObj["order"]] = (
                              <li className="cart_agree_item" key={key}>
                                <h1 className="cart_agree_item_title">
                                  {t(tempObj["title"])}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">{objLabel}</h2>
                              </li>
                            );
                            resolve();
                          } else if (tempObj["fabric"] === 3) {
                            temp3[tempObj["order"]] = (
                              <li className="cart_agree_item" key={key}>
                                <h1 className="cart_agree_item_title">
                                  {t(tempObj["title"])}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">{objLabel}</h2>
                              </li>
                            );
                            resolve();
                          } else {
                            resolve();
                          }
                        } else {
                          resolve();
                        }
                      }
                    });
                  });
                  Promise.all([...promiseArr3, ...promiseArr4]).then(() => {
                    desc[40] = (
                      <div className="basket_item_title_desc 4" key={40}>
                        {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                        <h3 className="basket_measurement_accordion_container">
                          <Accordion>
                            <Accordion.Item eventKey="0">
                              <ContextAwareToggleViewDetails
                                eventKey="0"
                                textOnHide={t("View Details")}
                                textOnShow={t("Hide Details")}
                                textOnHide2={t("Customize")}
                                textOnShow2={t("Customize")}
                                type={2}
                              />
                              <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                <div className="basket_item_title_container">
                                  <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                    <h1 className="cart_agree_item_fabrics_sorted_title 1">
                                      {t("General Details")}
                                    </h1>
                                    <ul>{temp5}</ul>
                                  </li>
                                  {cartValues["FabricId"] && (
                                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                                      <h1 className="cart_agree_item_fabrics_sorted_title">
                                        {t("Drapery")}
                                      </h1>
                                      <ul>
                                        <li className="cart_agree_item">
                                          <h1 className="cart_agree_item_title">
                                            {t("Material & Color")}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {pageLanguage === "fa"
                                              ? cartValues["FabricDesignFa"] +
                                                " / " +
                                                cartValues["FabricColorFa"]
                                              : CapitalizeAllWords(
                                                  cartValues["FabricDesignEn"] +
                                                    " / " +
                                                    cartValues["FabricColorEn"]
                                                )}
                                          </h2>
                                        </li>
                                        {cartValues["BorderOrTrimId"] &&
                                          cartValues["borderPosition"] && (
                                            <li className="cart_agree_item">
                                              <h1 className="cart_agree_item_title">
                                                {t("Decorative Border")}&nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? cartValues["BorderOrTrimDesignFa"] +
                                                    " / " +
                                                    cartValues["BorderOrTrimColorFa"] +
                                                    " \n " +
                                                    t(cartValues["borderPosition"])
                                                  : CapitalizeAllWords(
                                                      cartValues["BorderOrTrimDesignEn"] +
                                                        " / " +
                                                        cartValues["BorderOrTrimColorEn"] +
                                                        " \n " +
                                                        t(cartValues["borderPosition"])
                                                    )}
                                              </h2>
                                            </li>
                                          )}
                                        {cartValues["BorderOrTrimId"] &&
                                          !cartValues["borderPosition"] && (
                                            <li className="cart_agree_item">
                                              <h1 className="cart_agree_item_title">
                                                {t("Decorative Trim")}&nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? cartValues["BorderOrTrimDesignFa"] +
                                                    " / " +
                                                    cartValues["BorderOrTrimColorFa"]
                                                  : CapitalizeAllWords(
                                                      cartValues["BorderOrTrimDesignEn"] +
                                                        " / " +
                                                        cartValues["BorderOrTrimColorEn"]
                                                    )}
                                              </h2>
                                            </li>
                                          )}
                                        {temp1}
                                      </ul>
                                    </li>
                                  )}
                                  {cartValues["FabricId2"] && (
                                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                                      <h1 className="cart_agree_item_fabrics_sorted_title">
                                        {t("Sheer")}
                                      </h1>
                                      <ul>
                                        <li className="cart_agree_item">
                                          <h1 className="cart_agree_item_title">
                                            {t("Material & Color")}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {pageLanguage === "fa"
                                              ? cartValues["FabricDesignFa2"] +
                                                " / " +
                                                cartValues["FabricColorFa2"]
                                              : CapitalizeAllWords(
                                                  cartValues["FabricDesignEn2"] +
                                                    " / " +
                                                    cartValues["FabricColorEn2"]
                                                )}
                                          </h2>
                                        </li>
                                        {cartValues["BorderOrTrimId2"] &&
                                          cartValues["borderPosition2"] && (
                                            <li className="cart_agree_item">
                                              <h1 className="cart_agree_item_title">
                                                {t("Decorative Border")}&nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? cartValues["BorderOrTrimDesignFa2"] +
                                                    " / " +
                                                    cartValues["BorderOrTrimColorFa2"] +
                                                    " \n " +
                                                    t(cartValues["borderPosition2"])
                                                  : CapitalizeAllWords(
                                                      cartValues["BorderOrTrimDesignEn2"] +
                                                        " / " +
                                                        cartValues["BorderOrTrimColorEn2"] +
                                                        " \n " +
                                                        t(cartValues["borderPosition2"])
                                                    )}
                                              </h2>
                                            </li>
                                          )}
                                        {cartValues["BorderOrTrimId2"] &&
                                          !cartValues["borderPosition2"] && (
                                            <li className="cart_agree_item">
                                              <h1 className="cart_agree_item_title">
                                                {t("Decorative Trim")}&nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? cartValues["BorderOrTrimDesignFa2"] +
                                                    " / " +
                                                    cartValues["BorderOrTrimColorFa2"]
                                                  : CapitalizeAllWords(
                                                      cartValues["BorderOrTrimDesignEn2"] +
                                                        " / " +
                                                        cartValues["BorderOrTrimColorEn2"]
                                                    )}
                                              </h2>
                                            </li>
                                          )}
                                        {temp2}
                                      </ul>
                                    </li>
                                  )}
                                  {cartValues["PrivacyLayer"] &&
                                    cartValues["PrivacyLayer"] !== "none" &&
                                    cartValues["SheersDesignEn"] &&
                                    cartValues["SheersColorEn"] && (
                                      <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                                        <h1 className="cart_agree_item_fabrics_sorted_title">
                                          {t("Privacy Layer")}
                                        </h1>
                                        <ul>
                                          <li className="cart_agree_item">
                                            <h1 className="cart_agree_item_title">
                                              {t("Material & Color")}&nbsp;
                                            </h1>
                                            <h2 className="cart_agree_item_desc">
                                              {pageLanguage === "fa"
                                                ? cartValues["SheersDesignFa"] +
                                                  " / " +
                                                  cartValues["SheersColorFa"]
                                                : CapitalizeAllWords(
                                                    cartValues["SheersDesignEn"] +
                                                      " / " +
                                                      cartValues["SheersColorEn"]
                                                  )}
                                            </h2>
                                          </li>
                                          {temp3}
                                        </ul>
                                      </li>
                                    )}
                                  {!!temp4.length && (
                                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                                      <h1 className="cart_agree_item_fabrics_sorted_title">
                                        {t("Accessories")}
                                      </h1>
                                      <ul>{temp4}</ul>
                                    </li>
                                  )}
                                  <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_label">
                                    <h1 className="cart_agree_item_title">
                                      {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}&nbsp;
                                    </h1>
                                    <h2 className="cart_agree_item_desc">
                                      {pageLanguage === "fa"
                                        ? roomNameFa + (WindowName === "" ? "" : " / " + WindowName)
                                        : roomName + (WindowName === "" ? "" : " / " + WindowName)}
                                    </h2>
                                  </li>
                                  {moreInfoInput !== "" && (
                                    <li className="cart_agree_item">
                                      <h1 className="cart_agree_item_title">
                                        {t("Order Notes")}&nbsp;
                                      </h1>
                                      <ShowMoreLineLimited
                                        moreInfoInput={moreInfoInput}
                                        lines={3}
                                      />
                                    </li>
                                  )}
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </h3>
                      </div>
                    );
                    resolve();
                  });
                })
                .catch((e) => {
                  console.log(e);
                  resolve();
                });
            });
          } else if (SewingModelId === "0321") {
            promiseArr0[0] = new Promise((resolve, reject) => {
              GetUserProjectData(obj1, true)
                .then((cartValues) => {
                  let promiseArr4 = [];
                  if (cartValues["Accessories"] !== undefined) {
                    cartValues["Accessories"].forEach((obj, index) => {
                      if (obj["DesignNameFa"] !== undefined && obj["DesignNameEn"] !== undefined) {
                        promiseArr4[index] = new Promise((resolve, reject) => {
                          if (obj["DesignNameFa"] && obj["DesignNameEn"]) {
                            temp4[index] = (
                              <li className="cart_agree_item" key={"acc" + index}>
                                <h1 className="cart_agree_item_title">
                                  {pageLanguage === "fa"
                                    ? obj["DesignNameFa"]
                                    : obj["DesignNameEn"]}
                                </h1>
                                <h2 className="cart_agree_item_desc">
                                  {t("agree_Qty")}
                                  {NumToFa(obj["Qty"], pageLanguage)}
                                </h2>
                              </li>
                            );
                          }
                          resolve();
                        });
                      }
                    });
                  }

                  let promiseArr3 = [];
                  Object.keys(cartValues).forEach((key, index) => {
                    promiseArr3[index] = new Promise((resolve, reject) => {
                      let tempObj = userProjects.find((obj) => obj["cart"] === key);
                      if (
                        cartValues["DraperyHardware"] === "Rod" &&
                        cartValues["Hardware"] === "Same Hardware For All Curtains"
                      ) {
                        cartValues["BatonOptionB"] = cartValues["BatonOptionA"];
                        cartValues["BatonOptionC"] = cartValues["BatonOptionA"];
                      }
                      if (tempObj === undefined || cartValues[key] === undefined) {
                        resolve();
                      } else if (
                        tempObj["measurements"] &&
                        (obj["WindowWidth"] === undefined || obj["WindowHeight"] === undefined)
                      ) {
                        if (
                          obj["Width1"] ||
                          obj["Width2"] ||
                          obj["Width3"] ||
                          obj["Height1"] ||
                          obj["Height2"] ||
                          obj["Height3"] ||
                          obj["LeftWidthExt"] ||
                          obj["RightWidthExt"] ||
                          obj["HeightOfRodMount"] ||
                          obj["HeightOfCeilingToFloor"]
                        ) {
                          let tempObj2 = userProjects.find(
                            (obj) => obj["apiLabel"] === "WindowWidth"
                          );
                          desc[tempObj2["order"]] = (
                            <div className="basket_item_title_desc 5" key={i}>
                              <h3>{t("Measurements")}&nbsp;</h3>
                              <h4>{t("Almost Complete")}</h4>
                            </div>
                          );
                          resolve();
                        } else {
                          resolve();
                        }
                      } else {
                        if (
                          key === "WindowWidth" &&
                          tempObj["measurements"] &&
                          obj["WindowWidth"] &&
                          obj["WindowHeight"]
                        ) {
                          if (firstMeasurements) {
                            firstMeasurements = false;
                            if (obj["CalcWindowSize"]) {
                              desc[tempObj["order"]] = (
                                <div className="basket_item_title_desc 6" key={index}>
                                  <h3>{t("Measurements")}&nbsp;</h3>
                                  <h4 className="basket_measurement_accordion_container">
                                    <Accordion>
                                      <Accordion.Item eventKey="0">
                                        <ContextAwareToggleViewDetails
                                          eventKey="0"
                                          textOnHide={
                                            NumToFa(
                                              obj["WindowWidth"] + t("Measurements CM"),
                                              pageLanguage
                                            ) +
                                            " x " +
                                            NumToFa(
                                              obj["WindowHeight"] + t("Measurements CM"),
                                              pageLanguage
                                            )
                                          }
                                          textOnShow={t("Hide Details")}
                                        />
                                        <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                          <div className="basket_item_title_container">
                                            <GetMeasurementArray
                                              modelId={`${SewingModelId}`}
                                              cartValues={cartValues}
                                            />
                                          </div>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </h4>
                                </div>
                              );
                            } else {
                              desc[tempObj["order"]] = (
                                <div className="basket_item_title_desc 7" key={index}>
                                  <h3>{t("Measurements")}&nbsp;</h3>
                                  <h4>
                                    {NumToFa(
                                      obj["WindowWidth"] + t("Measurements CM"),
                                      pageLanguage
                                    ) +
                                      " x " +
                                      NumToFa(
                                        obj["WindowHeight"] + t("Measurements CM"),
                                        pageLanguage
                                      )}
                                  </h4>
                                </div>
                              );
                              resolve();
                            }
                            resolve();
                          } else {
                            resolve();
                          }
                        } else if (
                          key === "WindowHeight" &&
                          tempObj["measurements"] &&
                          obj["WindowWidth"] &&
                          obj["WindowHeight"]
                        ) {
                          resolve();
                        } else if (
                          (key === "PanelTypeOption" &&
                            cartValues["PanelTypeOption"] === "Customize Style Per Curtain") ||
                          (key === "Hardware" &&
                            cartValues["Hardware"] === "I Want To Customize Hardware Per Curtain")
                        ) {
                          resolve();
                        } else if (
                          tempObj["title"] !== "" &&
                          tempObj["lang"].indexOf(pageLanguage) > -1
                        ) {
                          let objLabel = "";
                          if (key === "ControlType" && cartValues["ControlType"] === "Motorized") {
                            objLabel =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(
                                    `${t(cartValues[key]?.toString())} / ${t(
                                      cartValues["MotorType"]?.toString()
                                    )}`
                                  )?.toString()
                                : `${t(cartValues[key]?.toString())} / ${t(
                                    cartValues["MotorType"]?.toString()
                                  )}`;
                          } else if (
                            key === "DraperyHardware" &&
                            cartValues["DraperyHardware"] !== "None"
                          ) {
                            objLabel =
                              t(cartValues[key]?.toString()) +
                              " / " +
                              (pageLanguage === "fa"
                                ? cartValues["RailDesignFaA"]
                                : cartValues["RailDesignEnA"]) +
                              " \n " +
                              (pageLanguage === "fa"
                                ? cartValues["RailColorFaA"]
                                : cartValues["RailColorEnA"]) +
                              " / " +
                              t(cartValues["BatonOptionA"]);
                          } else if (
                            key === "SheerHardware" &&
                            cartValues["SheerHardware"] !== "None"
                          ) {
                            if (cartValues["RailDesignEnB"] === "Motorized Track") {
                              objLabel =
                                t(cartValues[key]?.toString()) +
                                " / " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailDesignFaB"]
                                  : cartValues["RailDesignEnB"]);
                            } else {
                              objLabel =
                                t(cartValues[key]?.toString()) +
                                " / " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailDesignFaB"]
                                  : cartValues["RailDesignEnB"]) +
                                " \n " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailColorFaB"]
                                  : cartValues["RailColorEnB"]) +
                                " / " +
                                (cartValues["BatonOptionB"]
                                  ? t(cartValues["BatonOptionB"])
                                  : t(cartValues["ControlPositionB"]));
                            }
                          } else if (
                            key === "PrivacyLayerHardware" &&
                            cartValues["PrivacyLayerHardware"] !== "None"
                          ) {
                            if (cartValues["RailDesignEnC"] === "Motorized Track") {
                              objLabel =
                                t(cartValues[key]?.toString()) +
                                " / " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailDesignFaC"]
                                  : cartValues["RailDesignEnC"]);
                            } else {
                              objLabel =
                                t(cartValues[key]?.toString()) +
                                " / " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailDesignFaC"]
                                  : cartValues["RailDesignEnC"]) +
                                " \n " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailColorFaC"]
                                  : cartValues["RailColorEnC"]) +
                                " / " +
                                (cartValues["BatonOptionC"]
                                  ? t(cartValues["BatonOptionC"])
                                  : t(cartValues["ControlPositionC"]));
                            }
                          } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                            objLabel =
                              t("agree_Qty") + NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                          } else if (key === "HandCurtainEn2" || key === "HandCurtainFa2") {
                            objLabel =
                              t("agree_Qty") + NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                          } else if (tempObj["titleValue"] === null || true) {
                            if (tempObj["titlePostfix"] === "") {
                              objLabel =
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(
                                      `${t(cartValues[key]?.toString())}`
                                    )?.toString()
                                  : t(cartValues[key]?.toString());
                            } else {
                              objLabel =
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(
                                      `${cartValues[key]}`
                                    )?.toString() + t(tempObj["titlePostfix"])
                                  : cartValues[key]?.toString() + t(tempObj["titlePostfix"]);
                            }
                          } else {
                            if (tempObj["titleValue"][cartValues[key].toString()] === null) {
                              if (tempObj["titlePostfix"] === "") {
                                objLabel = t(cartValues[key].toString());
                              } else {
                                objLabel =
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(
                                        `${cartValues[key]}`
                                      ).toString() + t(tempObj["titlePostfix"])
                                    : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                              }
                            } else {
                              objLabel = t(tempObj["titleValue"][cartValues[key].toString()]);
                            }
                          }
                          if (tempObj["fabric"] === undefined) {
                            temp5[tempObj["order"]] = (
                              <li className="cart_agree_item" key={key}>
                                <h1 className="cart_agree_item_title">
                                  {t(tempObj["title"])}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">{objLabel}</h2>
                              </li>
                            );
                            resolve();
                          } else if (tempObj["fabric"] === 1) {
                            temp1[tempObj["order"]] = (
                              <li className="cart_agree_item" key={key}>
                                <h1 className="cart_agree_item_title">
                                  {t(tempObj["title"])}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">{objLabel}</h2>
                              </li>
                            );
                            resolve();
                          } else if (tempObj["fabric"] === 2) {
                            temp2[tempObj["order"]] = (
                              <li className="cart_agree_item" key={key}>
                                <h1 className="cart_agree_item_title">
                                  {t(tempObj["title"])}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">{objLabel}</h2>
                              </li>
                            );
                            resolve();
                          } else if (tempObj["fabric"] === 3) {
                            temp3[tempObj["order"]] = (
                              <li className="cart_agree_item" key={key}>
                                <h1 className="cart_agree_item_title">
                                  {t(tempObj["title"])}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">{objLabel}</h2>
                              </li>
                            );
                            resolve();
                          } else {
                            resolve();
                          }
                        } else {
                          resolve();
                        }
                      }
                    });
                  });
                  Promise.all([...promiseArr3, ...promiseArr4]).then(() => {
                    desc[40] = (
                      <div className="basket_item_title_desc 8" key={40}>
                        <h3 className="basket_measurement_accordion_container">
                          <Accordion>
                            <Accordion.Item eventKey="0">
                              <ContextAwareToggleViewDetails
                                eventKey="0"
                                textOnHide={t("View Details")}
                                textOnShow={t("Hide Details")}
                                textOnHide2={t("Customize")}
                                textOnShow2={t("Customize")}
                                type={2}
                              />
                              <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                <div className="basket_item_title_container">
                                  <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                    <h1 className="cart_agree_item_fabrics_sorted_title 2">
                                      {t("General Details")}
                                    </h1>
                                    <ul>{temp5}</ul>
                                  </li>
                                  {cartValues["FabricId"] && (
                                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                                      <h1 className="cart_agree_item_fabrics_sorted_title">
                                        {t("Drapery")}
                                      </h1>
                                      <ul>
                                        <li className="cart_agree_item">
                                          <h1 className="cart_agree_item_title">
                                            {t("Material & Color")}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {pageLanguage === "fa"
                                              ? cartValues["FabricDesignFa"] +
                                                " / " +
                                                cartValues["FabricColorFa"]
                                              : CapitalizeAllWords(
                                                  cartValues["FabricDesignEn"] +
                                                    " / " +
                                                    cartValues["FabricColorEn"]
                                                )}
                                          </h2>
                                        </li>
                                        {cartValues["BorderOrTrimId"] &&
                                          cartValues["borderPosition"] && (
                                            <li className="cart_agree_item">
                                              <h1 className="cart_agree_item_title">
                                                {t("Decorative Border")}&nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? cartValues["BorderOrTrimDesignFa"] +
                                                    " / " +
                                                    cartValues["BorderOrTrimColorFa"] +
                                                    " \n " +
                                                    t(cartValues["borderPosition"])
                                                  : CapitalizeAllWords(
                                                      cartValues["BorderOrTrimDesignEn"] +
                                                        " / " +
                                                        cartValues["BorderOrTrimColorEn"] +
                                                        " \n " +
                                                        t(cartValues["borderPosition"])
                                                    )}
                                              </h2>
                                            </li>
                                          )}
                                        {cartValues["BorderOrTrimId"] &&
                                          !cartValues["borderPosition"] && (
                                            <li className="cart_agree_item">
                                              <h1 className="cart_agree_item_title">
                                                {t("Decorative Trim")}&nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? cartValues["BorderOrTrimDesignFa"] +
                                                    " / " +
                                                    cartValues["BorderOrTrimColorFa"]
                                                  : CapitalizeAllWords(
                                                      cartValues["BorderOrTrimDesignEn"] +
                                                        " / " +
                                                        cartValues["BorderOrTrimColorEn"]
                                                    )}
                                              </h2>
                                            </li>
                                          )}
                                        {temp1}
                                      </ul>
                                    </li>
                                  )}
                                  {cartValues["FabricId2"] && (
                                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                                      <h1 className="cart_agree_item_fabrics_sorted_title">
                                        {t("Sheer")}
                                      </h1>
                                      <ul>
                                        <li className="cart_agree_item">
                                          <h1 className="cart_agree_item_title">
                                            {t("Material & Color")}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {pageLanguage === "fa"
                                              ? cartValues["FabricDesignFa2"] +
                                                " / " +
                                                cartValues["FabricColorFa2"]
                                              : CapitalizeAllWords(
                                                  cartValues["FabricDesignEn2"] +
                                                    " / " +
                                                    cartValues["FabricColorEn2"]
                                                )}
                                          </h2>
                                        </li>
                                        {cartValues["BorderOrTrimId2"] &&
                                          cartValues["borderPosition2"] && (
                                            <li className="cart_agree_item">
                                              <h1 className="cart_agree_item_title">
                                                {t("Decorative Border")}&nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? cartValues["BorderOrTrimDesignFa2"] +
                                                    " / " +
                                                    cartValues["BorderOrTrimColorFa2"] +
                                                    " \n " +
                                                    t(cartValues["borderPosition2"])
                                                  : CapitalizeAllWords(
                                                      cartValues["BorderOrTrimDesignEn2"] +
                                                        " / " +
                                                        cartValues["BorderOrTrimColorEn2"] +
                                                        " \n " +
                                                        t(cartValues["borderPosition2"])
                                                    )}
                                              </h2>
                                            </li>
                                          )}
                                        {cartValues["BorderOrTrimId2"] &&
                                          !cartValues["borderPosition2"] && (
                                            <li className="cart_agree_item">
                                              <h1 className="cart_agree_item_title">
                                                {t("Decorative Trim")}&nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? cartValues["BorderOrTrimDesignFa2"] +
                                                    " / " +
                                                    cartValues["BorderOrTrimColorFa2"]
                                                  : CapitalizeAllWords(
                                                      cartValues["BorderOrTrimDesignEn2"] +
                                                        " / " +
                                                        cartValues["BorderOrTrimColorEn2"]
                                                    )}
                                              </h2>
                                            </li>
                                          )}
                                        {temp2}
                                      </ul>
                                    </li>
                                  )}
                                  {cartValues["PrivacyLayer"] &&
                                    cartValues["PrivacyLayer"] !== "none" &&
                                    cartValues["SheersDesignEn"] &&
                                    cartValues["SheersColorEn"] && (
                                      <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                                        <h1 className="cart_agree_item_fabrics_sorted_title">
                                          {t("Privacy Layer")}
                                        </h1>
                                        <ul>
                                          <li className="cart_agree_item">
                                            <h1 className="cart_agree_item_title">
                                              {t("Material & Color")}&nbsp;
                                            </h1>
                                            <h2 className="cart_agree_item_desc">
                                              {pageLanguage === "fa"
                                                ? cartValues["SheersDesignFa"] +
                                                  " / " +
                                                  cartValues["SheersColorFa"]
                                                : CapitalizeAllWords(
                                                    cartValues["SheersDesignEn"] +
                                                      " / " +
                                                      cartValues["SheersColorEn"]
                                                  )}
                                            </h2>
                                          </li>
                                          {temp3}
                                        </ul>
                                      </li>
                                    )}
                                  {!!temp4.length && (
                                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                                      <h1 className="cart_agree_item_fabrics_sorted_title">
                                        {t("Accessories")}
                                      </h1>
                                      <ul>{temp4}</ul>
                                    </li>
                                  )}
                                  <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_label">
                                    <h1 className="cart_agree_item_title">
                                      {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}&nbsp;
                                    </h1>
                                    <h2 className="cart_agree_item_desc">
                                      {pageLanguage === "fa"
                                        ? roomNameFa + (WindowName === "" ? "" : " / " + WindowName)
                                        : roomName + (WindowName === "" ? "" : " / " + WindowName)}
                                    </h2>
                                  </li>
                                  {moreInfoInput !== "" && (
                                    <li className="cart_agree_item">
                                      <h1 className="cart_agree_item_title">
                                        {t("Order Notes")}&nbsp;
                                      </h1>
                                      <ShowMoreLineLimited
                                        moreInfoInput={moreInfoInput}
                                        lines={3}
                                      />
                                    </li>
                                  )}
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </h3>
                      </div>
                    );
                    resolve();
                  });
                })
                .catch((e) => {
                  console.log(e);
                  resolve();
                });
            });
          } else {
            promiseArr0[0] = new Promise((resolve, reject) => {
              let promiseArr3 = [];
              Object.keys(obj).forEach((key, i) => {
                promiseArr3[i] = new Promise((resolve, reject) => {
                  let tempObj = userProjects.find((obj) => obj["apiLabel"] === key);
                  if (tempObj === undefined || obj[key] === undefined) {
                    resolve();
                  } else if (
                    tempObj["measurements"] &&
                    (obj["WindowWidth"] === undefined || obj["WindowHeight"] === undefined)
                  ) {
                    if (
                      obj["Width1"] ||
                      obj["Width2"] ||
                      obj["Width3"] ||
                      obj["Height1"] ||
                      obj["Height2"] ||
                      obj["Height3"] ||
                      obj["LeftWidthExt"] ||
                      obj["RightWidthExt"] ||
                      obj["HeightOfRodMount"] ||
                      obj["HeightOfCeilingToFloor"]
                    ) {
                      let tempObj2 = userProjects.find((obj) => obj["apiLabel"] === "WindowWidth");
                      desc[tempObj2["order"]] = (
                        <div className="basket_item_title_desc 9" key={i}>
                          <h3>{t("Measurements")}&nbsp;</h3>
                          <h4>{t("Almost Complete")}</h4>
                        </div>
                      );
                      resolve();
                    } else {
                      resolve();
                    }
                  } else if (
                    tempObj["apiLabel"] === "WindowWidth" &&
                    tempObj["measurements"] &&
                    obj["WindowWidth"] &&
                    obj["WindowHeight"]
                  ) {
                    if (firstMeasurements) {
                      firstMeasurements = false;
                      if (obj["CalcWindowSize"]) {
                        GetUserProjectData(obj1, true)
                          .then((temp) => {
                            desc[tempObj["order"]] = (
                              <div className="basket_item_title_desc 10" key={i}>
                                <h3>{t("Measurements")}&nbsp;</h3>
                                <h4 className="basket_measurement_accordion_container">
                                  <Accordion>
                                    <Accordion.Item eventKey="0">
                                      <ContextAwareToggleViewDetails
                                        eventKey="0"
                                        textOnHide={
                                          NumToFa(
                                            obj["WindowWidth"] + t("Measurements CM"),
                                            pageLanguage
                                          ) +
                                          " x " +
                                          NumToFa(
                                            obj["WindowHeight"] + t("Measurements CM"),
                                            pageLanguage
                                          )
                                        }
                                        textOnShow={t("Hide Details")}
                                      />
                                      <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                        <div className="basket_item_title_container">
                                          <GetMeasurementArray
                                            modelId={`${SewingModelId}`}
                                            cartValues={temp}
                                          />
                                        </div>
                                      </Accordion.Body>
                                    </Accordion.Item>
                                  </Accordion>
                                </h4>
                              </div>
                            );
                            resolve();
                          })
                          .catch((err) => {
                            console.log(err);
                            resolve();
                          });
                      } else {
                        desc[tempObj["order"]] = (
                          <div className="basket_item_title_desc 11" key={i}>
                            <h3>{t("Measurements")}&nbsp;</h3>
                            <h4>
                              {NumToFa(obj["WindowWidth"] + t("Measurements CM"), pageLanguage) +
                                " x " +
                                NumToFa(obj["WindowHeight"] + t("Measurements CM"), pageLanguage)}
                            </h4>
                          </div>
                        );
                        resolve();
                      }
                    } else {
                      resolve();
                    }
                  } else if (
                    tempObj["apiLabel"] === "WindowHeight" &&
                    tempObj["measurements"] &&
                    obj["WindowWidth"] &&
                    obj["WindowHeight"]
                  ) {
                    resolve();
                  } else {
                    if (tempObj["title"] !== "" && tempObj["lang"].indexOf(pageLanguage) > -1) {
                      let objLabel = "";
                      let apiValue =
                        obj[tempObj["apiLabel"]] === null
                          ? "null"
                          : obj[tempObj["apiLabel"]].toString();
                      if (
                        tempObj["apiLabel"] === "ControlType" &&
                        obj["ControlType"] === "Motorized"
                      ) {
                        objLabel =
                          pageLanguage === "fa"
                            ? NumberToPersianWord.convertEnToPe(
                                `${t(obj[key].toString())} / ${t(obj["MotorType"].toString())}`
                              ).toString()
                            : `${t(obj[key].toString())} / ${t(obj["MotorType"].toString())}`;
                      } else if (tempObj["titleValue"] === null) {
                        if (tempObj["titlePostfix"] === "") {
                          objLabel =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(
                                  `${t(apiValue.toString())}`
                                ).toString()
                              : t(apiValue.toString());
                        } else {
                          objLabel =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${apiValue}`).toString() +
                                t(tempObj["titlePostfix"])
                              : apiValue.toString() + t(tempObj["titlePostfix"]);
                        }
                      } else {
                        if (tempObj["titleValue"][apiValue.toString()] === null) {
                          if (tempObj["titlePostfix"] === "") {
                            objLabel = t(apiValue.toString());
                          } else {
                            objLabel =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${apiValue}`).toString() +
                                  t(tempObj["titlePostfix"])
                                : apiValue.toString() + t(tempObj["titlePostfix"]);
                          }
                        } else {
                          objLabel = t(tempObj["titleValue"][apiValue.toString()]);
                        }
                      }
                      temp5[tempObj["order"]] = (
                        <li className="cart_agree_item" key={key}>
                          <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                        </li>
                      );
                      resolve();
                    } else {
                      resolve();
                    }
                  }
                });
              });
              Promise.all(promiseArr3).then(() => {
                desc[40] = (
                  <div className="basket_item_title_desc 12" key={40}>
                    {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                    <h3 className="basket_measurement_accordion_container">
                      <Accordion>
                        <Accordion.Item eventKey="0">
                          <ContextAwareToggleViewDetails
                            eventKey="0"
                            textOnHide={t("View Details")}
                            textOnShow={t("Hide Details")}
                            textOnHide2={t("Customize")}
                            textOnShow2={t("Customize")}
                            type={2}
                          />
                          <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                            <div className="basket_item_title_container">
                              <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                <h1 className="cart_agree_item_fabrics_sorted_title 3">
                                  {t("General Details")}
                                </h1>
                                <ul>{temp5}</ul>
                              </li>
                              <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_label">
                                <h1 className="cart_agree_item_title">
                                  {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">
                                  {pageLanguage === "fa"
                                    ? roomNameFa + (WindowName === "" ? "" : " / " + WindowName)
                                    : roomName + (WindowName === "" ? "" : " / " + WindowName)}
                                </h2>
                              </li>
                              {moreInfoInput !== "" && (
                                <li className="basket_item_title_desc 13">
                                  <h1 className="cart_agree_item_title">
                                    {t("Order Notes")}&nbsp;
                                  </h1>
                                  <ShowMoreLineLimited moreInfoInput={moreInfoInput} lines={3} />
                                </li>
                              )}
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </h3>
                  </div>
                );
                resolve();
              });
            });
          }

          Promise.all(promiseArr0).then(() => {
            // console.log(desc);
            tempProjectArr[i] = (
              <li
                className="drapery_basket_item"
                key={i}
                ref={(ref) => (projectRef.current[projectId] = ref)}
              >
                <span className="basket_item_title">
                  <div className="basket_item_image_container">
                    <img
                      src={imgUrl(photoUrl)}
                      alt=""
                      className="basket_item_img"
                    />
                  </div>
                  <div className="basket_item_title_container">
                    <div className="basket_item_title_name desktop_only basket_item_title_name_projects">
                      {pageLanguage === "fa"
                        ? convertToPersian(defaultModelNameFa) + " سفارشی "
                        : "Custom " + defaultModelName}
                      <h5>
                        &nbsp;
                        {pageLanguage === "fa"
                          ? obj["RoomNameFa"] +
                            (!obj["WindowName"] ? "" : " / " + obj["WindowName"])
                          : obj["RoomNameEn"] +
                            (!obj["WindowName"] ? "" : " / " + obj["WindowName"])}
                      </h5>
                    </div>
                    <div className="basket_item_title_name mobile_only">
                      <span className="basket_item_title_mob_container">
                        <h5>
                          <h4>
                            {pageLanguage === "fa"
                              ? convertToPersian(defaultModelNameFa) + " سفارشی "
                              : "Custom " + defaultModelName}
                            &nbsp;&nbsp;
                          </h4>
                          {pageLanguage === "fa"
                            ? obj["RoomNameFa"] +
                              (!obj["WindowName"] ? "" : " / " + obj["WindowName"])
                            : obj["RoomNameEn"] +
                              (!obj["WindowName"] ? "" : " / " + obj["WindowName"])}
                        </h5>
                      </span>
                      <span className="basket_item_title_mob_price_container">
                        {GetPrice(obj["Price"], pageLanguage, t("TOMANS"), isTabletOrMobile)}
                      </span>
                    </div>
                    {SewingModelId === "0326" && (
                      <div className="basket_item_title_desc 14">
                        <h3>{pageLanguage === "fa" ? "پارچه/رنگ" : "Fabric/Color"}&nbsp;</h3>
                        <h4>
                          <div className={`dk_curtain_preview_container`}>
                            <Accordion>
                              <Accordion.Item eventKey="0">
                                <ContextAwareToggleViewDetails
                                  eventKey="0"
                                  textOnHide={t("View Details")}
                                  textOnShow={t("Hide Details")}
                                />
                                <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                  <div className="dk_curtain_preview_detail_container">
                                    {obj["CurtainArr"].map((item, i) => (
                                      <div key={i} className="dk_curtain_preview_detail">
                                        <h2>
                                          {pageLanguage === "en"
                                            ? "VANE " + (+i + +1) + ":"
                                            : " شال" +
                                              NumberToPersianWord.convertEnToPe(`${+i + +1}`) +
                                              ":"}
                                        </h2>
                                        <h3>
                                          &nbsp;
                                          {(pageLanguage === "en"
                                            ? CapitalizeAllWords(item["DesignEnName"])
                                            : item["DesignName"]
                                          ).toString() +
                                            " / " +
                                            (pageLanguage === "en"
                                              ? CapitalizeAllWords(item["ColorEnName"])
                                              : item["ColorName"]
                                            ).toString()}
                                        </h3>
                                      </div>
                                    ))}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </div>
                        </h4>
                      </div>
                    )}
                    {SewingModelId === "0325" && (
                      <>
                        <div className="basket_item_title_desc 15">
                          <h3>{t("dualRoller_step1")}&nbsp;</h3>
                          <h4>
                            {pageLanguage === "fa"
                              ? obj["FabricDesignFa"] + " / " + obj["FabricColorFa"]
                              : obj["FabricDesignEn"] + " / " + obj["FabricColorEn"]}
                          </h4>
                        </div>
                        <div className="basket_item_title_desc 16">
                          <h3>{t("dualRoller_step2")}&nbsp;</h3>
                          <h4>
                            {pageLanguage === "fa"
                              ? obj["FabricDesignFa2"] + " / " + obj["FabricColorFa2"]
                              : obj["FabricDesignEn2"] + " / " + obj["FabricColorEn2"]}
                          </h4>
                        </div>
                      </>
                    )}

                    {(SewingModelId === "0303" ||
                      SewingModelId === "0324" ||
                      SewingModelId === "0097") && (
                      <>
                        {obj["FabricId"] && (
                          <div className="basket_item_title_desc">
                            <h3>{t("Material & Color")}&nbsp;</h3>
                            <h4>
                              {pageLanguage === "fa"
                                ? obj["FabricDesignFa"] + " / " + obj["FabricColorFa"]
                                : CapitalizeAllWords(
                                    obj["FabricDesignEn"] + " / " + obj["FabricColorEn"]
                                  )}
                            </h4>
                          </div>
                        )}
                      </>
                    )}
                    {desc}
                    <div className="basket_item_qty_mob_container mobile_only">
                      <QTY
                        qty={obj1["WindowCount"]}
                        minQty={1}
                        maxQty={10}
                        isReadOnly={false}
                        pageLanguage={pageLanguage}
                        NumberToPersianWord={NumberToPersianWord}
                        handleIncrement={() => setProjectCount(projectId, 0, 1)}
                        handleDecrement={() => setProjectCount(projectId, 0, -1)}
                        handleInputChange={(value) => setProjectCount(projectId, value)}
                      />
                      <div className="basket_item_qty_mob_price">
                        {obj["IsCompleted"]
                          ? GetPrice(
                              obj["Price"] * obj1["WindowCount"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : "---"}
                      </div>
                    </div>
                    {obj["ZipCode"] && obj["ZipCode"] !== "" && (
                      <div className="basket_zipcode_container">
                        <div className="basket_zipcode_left">
                          <h1 className="basket_zipcode_title">{t("basket_zipcode_text1")}</h1>
                          <h2 className="basket_zipcode_title2">
                            {t("basket_zipcode_text3")}
                            {obj["ZipCode"]}
                          </h2>
                          <button
                            className="basket_zipcode_btn text_underline"
                            onClick={() => removeZipcode(projectId)}
                          >
                            {t("Remove")}
                          </button>
                        </div>
                        <div className="basket_zipcode_right">
                          <h2 className="basket_zipcode_price">
                            {GetPrice(
                              obj["InstallAmount"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                          </h2>
                        </div>
                      </div>
                    )}
                    <div className="basket_item_delivery_section">
                      <div className="basket_item_delivery_avail">
                        <h2 className="basket_item_delivery_desc">
                          {zipcode && zipcode !== ""
                            ? t("AVAILABILITY_desc")
                            : t("AVAILABILITY_desc2")}
                        </h2>
                      </div>
                      <div className="basket_item_delivery_return">
                        <h2 className="basket_item_delivery_desc">
                          {t("RETURNS_desc")}
                          <p className="text_underline">{t("Return Policy")}</p>
                        </h2>
                      </div>
                    </div>
                    <div className="basket_item_desc_button mobile_only">
                      {!obj["IsCompleted"] && !!userProjects.length && (
                        <Link
                          className="projects_add_to_cart_btn btn projects_add_to_cart_btn_long"
                          to={
                            "/" +
                            pageLanguage +
                            projectData[obj["SewingModelId"]]["route"] +
                            (obj1["PreorderText"]["PageType"]
                              ? "/" + obj1["PreorderText"]["PageType"]
                              : "") +
                            "/Saved-Projects/" +
                            obj1["SewingOrderId"] +
                            "/Page-ID/" +
                            obj1["PreorderText"]["PageId"]
                          }
                        >
                          {t("FINISH CONFIGURING")}
                        </Link>
                      )}
                      {obj["IsCompleted"] && !!userProjects.length && (
                        <>
                          <button
                            className="projects_add_to_cart_btn btn 1"
                            ref={(ref) => (projectsButtonRef.current[i] = ref)}
                            onClick={() => {
                              projectsButtonRef.current[i].disabled = true;
                              projectsButtonRef.current[i].innerHTML = t("ADDING...");
                              addProjectToBag(obj1, i);
                            }}
                          >
                            {t("ADD TO BAG")}
                          </button>
                          <Link
                            className="projects_edit_btn btn 1"
                            to={
                              "/" +
                              pageLanguage +
                              projectData[obj["SewingModelId"]]["route"] +
                              (obj1["PreorderText"]["PageType"]
                                ? "/" + obj1["PreorderText"]["PageType"]
                                : "") +
                              "/Saved-Projects/" +
                              obj1["SewingOrderId"] +
                              "/Page-ID/" +
                              obj1["PreorderText"]["PageId"]
                            }
                          >
                            {t("EDIT")}
                          </Link>
                        </>
                      )}
                      <button
                        className="btn basket_button basket_button_remove"
                        onClick={() => setProjectCount(projectId, 0)}
                      >
                        {t("REMOVE")}
                      </button>
                    </div>
                  </div>
                </span>
                <span className="basket_item_price desktop_only">
                  {obj["IsCompleted"]
                    ? GetPrice(obj["Price"], pageLanguage, t("TOMANS"), isTabletOrMobile)
                    : "---"}
                </span>
                <span className="basket_item_qty desktop_only">
                  <QTY
                    qty={obj1["WindowCount"]}
                    minQty={1}
                    maxQty={10}
                    isReadOnly={false}
                    pageLanguage={pageLanguage}
                    NumberToPersianWord={NumberToPersianWord}
                    handleIncrement={() => setProjectCount(projectId, 0, 1)}
                    handleDecrement={() => setProjectCount(projectId, 0, -1)}
                    handleInputChange={(value) => setProjectCount(projectId, value)}
                  />
                  <div className="basket_item_qty_button">
                    <button
                      className="basket_button basket_button_remove"
                      onClick={() => setProjectCount(projectId, 0)}
                    >
                      {t("X REMOVE")}
                    </button>
                  </div>
                </span>
                <span className="basket_item_total desktop_only">
                  {obj["IsCompleted"]
                    ? GetPrice(
                        obj["Price"] * obj1["WindowCount"],
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )
                    : "---"}
                </span>

                <span
                  className={
                    uploadedFiles && uploadedFiles.length > 0
                      ? "basket_item_visible1"
                      : "basket_item_hidden1"
                  }
                >
                  {uploadedFiles && uploadedFiles.length > 0 && (
                    <div className="select_container">
                      <Select
                        className="select"
                        placeholder={t("UPLOADED IMAGES/PDF")}
                        portal={document.body}
                        dropdownPosition="bottom"
                        dropdownHandle={false}
                        dropdownGap={0}
                        dropdownRenderer={({ props, state, methods }) => (
                          <CustomDropdownFiles props={props} state={state} methods={methods} />
                        )}
                        contentRenderer={({ props, state, methods }) => (
                          <CustomControlFiles props={props} state={state} methods={methods} />
                        )}
                        onChange={(selected) => {
                          if (selected[0] !== undefined) {
                            deleteFileFromProject(selected[0], projectId);
                          }
                        }}
                        options={tempSelectArr}
                      />
                    </div>
                  )}
                </span>

                {!obj["IsCompleted"] && !!userProjects.length && (
                  <span className="basket_item_btn desktop_only">
                    <Link
                      className="projects_add_to_cart_btn btn projects_add_to_cart_btn_long"
                      to={
                        "/" +
                        pageLanguage +
                        projectData[obj["SewingModelId"]]["route"] +
                        (obj1["PreorderText"]["PageType"]
                          ? "/" + obj1["PreorderText"]["PageType"]
                          : "") +
                        "/Saved-Projects/" +
                        obj1["SewingOrderId"] +
                        "/Page-ID/" +
                        obj1["PreorderText"]["PageId"]
                      }
                    >
                      {t("FINISH CONFIGURING")}
                    </Link>
                  </span>
                )}
                {/* {(()=> {
      
          console.log(`obj1`, obj1);
          console.log(` projectData[obj["SewingModelId"]]`,  projectData[obj["SewingModelId"]]);
          console.log(`obj1["PreorderText"]`, obj1["PreorderText"]);
        })()} */}

                {obj["IsCompleted"] && !!userProjects.length && (
                  <span className="basket_item_btn desktop_only">
                    <button
                      className="projects_add_to_cart_btn btn 2"
                      ref={(ref) => (projectsButtonRef.current[i] = ref)}
                      onClick={() => {
                        projectsButtonRef.current[i].disabled = true;
                        projectsButtonRef.current[i].innerHTML = t("ADDING...");
                        addProjectToBag(obj1, i);
                      }}
                    >
                      {t("ADD TO BAG")}
                    </button>
                    <Link
                      className="projects_edit_btn btn 2"
                      to={
                        "/" +
                        pageLanguage +
                        projectData[obj["SewingModelId"]]["route"] +
                        (obj1["PreorderText"]["PageType"]
                          ? "/" + obj1["PreorderText"]["PageType"]
                          : "/" + "Drapery&Sheers") +
                        "/Saved-Projects/" +
                        obj1["SewingOrderId"] +
                        "/Page-ID/" +
                        (obj1["PreorderText"]["PageId"] || 24)
                      }
                    >
                      {t("EDIT")}
                    </Link>
                  </span>
                )}

                <span className="basket_item_hidden2" />
              </li>
            );
            resolve();
          });
        });
      });
    Promise.all(promiseArr).then(() => {
      setUserProjectsRender(tempProjectArr);
      setFiles(tempFiles);
    });
  }

  function setProjectCount(projectId, numValue, minusPlus) {
    let temp = JSON.parse(JSON.stringify(userProjects));
    let tempProject = temp.find((opt) => opt["SewingOrderId"] === projectId);
    tempProject["Count"] = tempProject["WindowCount"];

    if (tempProject !== {}) {
      if (minusPlus !== undefined) {
        if (tempProject["Count"] + minusPlus <= 0 || tempProject["Count"] + minusPlus > 10)
          setProjectCount(projectId, tempProject["Count"] + minusPlus);
        else {
          tempProject["Count"] = tempProject["Count"] + minusPlus;
          editProject(tempProject);
        }
      } else {
        if (numValue === "") {
          tempProject["Count"] = 1;
          editProject(tempProject);
        } else if (!isNaN(numValue) || numValue === 10 || numValue === "10") {
          if (parseInt(numValue) > 10) {
            tempProject["Count"] = 10;
            editProject(tempProject);
          } else if (parseInt(numValue) <= 0) {
            deleteUserProject(projectId);
          } else {
            tempProject["Count"] = parseInt(numValue);
            editProject(tempProject);
          }
        }
      }
    }
  }

  function removeZipcode(refIndex) {
    let temp = JSON.parse(JSON.stringify(userProjects));
    let tempProject = temp.find((opt) => opt["SewingOrderId"] === refIndex);
    tempProject["Count"] = tempProject["WindowCount"];
    tempProject["PreorderText"]["InstallAmount"] = 0;
    tempProject["PreorderText"]["TransportationAmount"] = 0;
    tempProject["PreorderText"]["ZipCode"] = "";
    tempProject["PreorderText"]["NeedInstall"] = false;
    tempProject["InstallAmount"] = 0;
    tempProject["TransportationAmount"] = 0;
    tempProject["ZipCode"] = "";
    tempProject["NeedInstall"] = false;
    editBasketProject(tempProject);
  }

  function editProject(projectObj) {
    projectObj["WindowCount"] = projectObj["Count"];
    projectObj["PreorderText"]["WindowCount"] = projectObj["Count"];
    projectObj["PreorderText"]["Count"] = projectObj["Count"];
    axios
      .post(baseURLEditProject, projectObj, {
        headers: authHeader(),
      })
      .then(() => {
        getUserProjects();
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              editProject(projectObj);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        }
      });
  }

  function deleteUserProject(projectId) {
    projectRef.current[projectId].className = "drapery_basket_item is_loading";
    axios
      .delete(baseURLDeleteProject, {
        params: {
          id: projectId,
        },
        headers: authHeader(),
      })
      .then((response) => {
        if (projectRef.current[projectId]) {
          projectRef.current[projectId].className = "drapery_basket_item";
        }
        getUserProjects();
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              deleteUserProject(projectId);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          if (projectRef.current[projectId]) {
            projectRef.current[projectId].className = "drapery_basket_item";
          }
        }
      });
  }

  function modalHandleClose(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = false;
    setModals(tempModals);
  }

  function modalHandleShow(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = true;
    setModals(tempModals);
  }

  function setBasketNumber(cart, refIndex, numValue, minusPlus) {
    let temp = JSON.parse(JSON.stringify(cart))["CartDetails"];
    let tempProjectContainer = temp.find((opt) => opt["CartDetailId"] === refIndex);

    if (Object.keys(tempProjectContainer).length !== 0) {
      let tempProject = tempProjectContainer["SewingOrder"];
      tempProject["Count"] = tempProject["WindowCount"];
      if (minusPlus !== undefined) {
        if (tempProject["Count"] + minusPlus <= 0 || tempProject["Count"] + minusPlus > 10)
          setBasketNumber(cart, refIndex, tempProject["Count"] + minusPlus);
        else {
          tempProject["Count"] = tempProject["Count"] + minusPlus;
          editBasketProject(tempProject);
        }
      } else {
        if (numValue === "") {
          tempProject["Count"] = 1;
          editBasketProject(tempProject);
        } else if (!isNaN(numValue) || numValue === 10 || numValue === "10") {
          if (parseInt(numValue) > 10) {
            tempProject["Count"] = 10;
            editBasketProject(tempProject);
          } else if (parseInt(numValue) <= 0) {
            deleteBasketProject(refIndex);
          } else {
            tempProject["Count"] = parseInt(numValue);
            editBasketProject(tempProject);
          }
        }
      }
    }
  }

  function editBasketProject(projectObj) {
    projectObj["WindowCount"] = projectObj["Count"];
    projectObj["PreorderText"]["WindowCount"] = projectObj["Count"];
    axios
      .post(baseURLEditProject, projectObj, {
        headers: authHeader(),
      })
      .then(() => {
        renderCart();
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              editBasketProject(projectObj);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        }
      });
  }

  function deleteBasketProject(refIndex) {
    if (draperyRef.current[refIndex]) {
      draperyRef.current[refIndex].className = "custom_cart_item is_loading";
    }
    axios
      .post(
        baseURLDeleteBasketProject + "/" + refIndex,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (draperyRef.current[refIndex]) {
          draperyRef.current[refIndex].className = "custom_cart_item";
        }
        renderCart();
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              deleteBasketProject(refIndex);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          if (draperyRef.current[refIndex]) {
            draperyRef.current[refIndex].className = "custom_cart_item";
          }
        }
      });
  }

  function addProjectToBag(projectObj, index) {
    // console.log(projectObj, index);
    setBagProjectObject(projectObj);
    let tempPostObj = projectObj;
    let tempBagPrice = 0;
    let tempArr = [];
    let temp1 = [];
    let temp2 = [];
    let temp3 = [];
    let temp4 = [];
    let temp5 = [];
    let SewingModelId = projectObj["PreorderText"]["SewingModelId"];

    GetUserProjectData(projectObj, true).then((temp) => {
      //     // console.log(temp);
      let userProjects = JSON.parse(JSON.stringify(UserProjects))[SewingModelId]["data"];

      let cartValues = temp;

      let defaultModelName = projectObj["PreorderText"]["ModelNameEn"];
      let defaultModelNameFa = projectObj["PreorderText"]["ModelNameFa"];
      // PreorderText is the saved snapshot (incl. SewingOrderDetails/FabricId).
      // Root SewingOrderDetails from GetProjects is often empty, which skipped GetPrice.
      const preorderText = projectObj["PreorderText"] || {};
      tempPostObj = {
        ...projectObj,
        ...preorderText,
        PreorderText: preorderText,
        SewingOrderId: projectObj["SewingOrderId"],
        SewingOrderAttachments: projectObj["SewingOrderAttachments"],
        WindowCount: 1,
        SewingModelId: preorderText["SewingModelId"],
      };
      if (
        (!tempPostObj["SewingOrderDetails"] ||
          !tempPostObj["SewingOrderDetails"][0] ||
          tempPostObj["SewingOrderDetails"][0]["FabricId"] === undefined) &&
        preorderText["SewingOrderDetails"] &&
        preorderText["SewingOrderDetails"][0]
      ) {
        tempPostObj["SewingOrderDetails"] = JSON.parse(
          JSON.stringify(preorderText["SewingOrderDetails"])
        );
      }

      console.log(tempPostObj);
      if (
        tempPostObj["SewingOrderDetails"] &&
        tempPostObj["SewingOrderDetails"][0] !== undefined &&
        tempPostObj["SewingOrderDetails"][0]["FabricId"] !== undefined &&
        tempPostObj["PreorderText"] !== undefined
      ) {
        // console.log(JSON.stringify(tempPostObj));
        axios
          .post(baseURLPrice, tempPostObj)
          .then((response) => {
            tempBagPrice = response.data["Price"];
            temp["Price"] = response.data["Price"];
            if (response.data["InstallAmount"]) {
              temp["InstallAmount"] = response.data["InstallAmount"];
              temp["TransportationAmount"] = response.data["TransportationAmount"];
            }

            projectObj["Price"] = response.data["Price"];
            projectObj["PreorderText"]["Price"] = response.data["Price"];
            setBagProjectObject(projectObj);

            let roomNameFa = cartValues["RoomNameFa"];
            let roomName = cartValues["RoomNameEn"];
            let WindowName = cartValues["WindowName"] === undefined ? "" : cartValues["WindowName"];
            let moreInfoInput =
              cartValues["moreInfoInput"] === undefined ? "" : cartValues["moreInfoInput"];

            let promiseArr = [];
            if (cartValues["Accessories"] !== undefined) {
              cartValues["Accessories"].forEach((obj, index) => {
                if (obj["DesignNameFa"] !== undefined && obj["DesignNameEn"] !== undefined) {
                  promiseArr[index] = new Promise((resolve, reject) => {
                    temp4[index] = (
                      <li className="cart_agree_item" key={"acc" + index}>
                        <h1 className="cart_agree_item_title">
                          {pageLanguage === "fa" ? obj["DesignNameFa"] : obj["DesignNameEn"]}
                        </h1>
                        <h2 className="cart_agree_item_desc">
                          {t("agree_Qty")}
                          {NumToFa(obj["Qty"], pageLanguage)}
                        </h2>
                      </li>
                    );
                    resolve();
                  });
                }
              });
            }

            let promiseArr2 = [];
            Object.keys(cartValues).forEach((key, index) => {
              promiseArr2[index] = new Promise((resolve, reject) => {
                let tempObj = userProjects.find((obj) => obj["cart"] === key);
                if (tempObj === undefined || cartValues[key] === undefined) {
                  // window.location.reload();
                  console.log(key);
                  resolve();
                } else {
                  if (key === "WindowHeight" || key === "WindowWidth") {
                    resolve();
                  } else if (
                    (key === "PanelTypeOption" &&
                      cartValues["PanelTypeOption"] === "Customize Style Per Curtain") ||
                    (key === "Hardware" &&
                      cartValues["Hardware"] === "I Want To Customize Hardware Per Curtain")
                  ) {
                    resolve();
                  } else if (
                    tempObj["title"] !== "" &&
                    tempObj["lang"].indexOf(pageLanguage) > -1
                  ) {
                    let objLabel = "";
                    if (key === "ControlType" && cartValues["ControlType"] === "Motorized") {
                      objLabel =
                        pageLanguage === "fa"
                          ? NumberToPersianWord.convertEnToPe(
                              `${t(cartValues[key].toString())} / ${t(
                                cartValues["MotorType"].toString()
                              )}`
                            ).toString()
                          : `${t(cartValues[key].toString())} / ${t(
                              cartValues["MotorType"].toString()
                            )}`;
                    }

                    // }
                    else if (
                      key === "DraperyHardware" &&
                      cartValues["DraperyHardware"] !== "None"
                    ) {
                      objLabel =
                        t(cartValues[key].toString()) +
                        " / " +
                        (pageLanguage === "fa"
                          ? cartValues["RailDesignFaA"]
                          : cartValues["RailDesignEnA"]) +
                        " \n " +
                        (pageLanguage === "fa"
                          ? cartValues["RailColorFaA"]
                          : cartValues["RailColorEnA"]) +
                        " / " +
                        t(cartValues["BatonOptionA"]);
                    } else if (key === "SheerHardware" && cartValues["SheerHardware"] !== "None") {
                      if (cartValues["RailDesignEnB"] === "Motorized Track") {
                        objLabel =
                          t(cartValues[key].toString()) +
                          " / " +
                          (pageLanguage === "fa"
                            ? cartValues["RailDesignFaB"]
                            : cartValues["RailDesignEnB"]);
                      } else {
                        objLabel =
                          t(cartValues[key].toString()) +
                          " / " +
                          (pageLanguage === "fa"
                            ? cartValues["RailDesignFaB"]
                            : cartValues["RailDesignEnB"]) +
                          " \n " +
                          (pageLanguage === "fa"
                            ? cartValues["RailColorFaB"]
                            : cartValues["RailColorEnB"]) +
                          " / " +
                          (cartValues["BatonOptionB"]
                            ? t(cartValues["BatonOptionB"])
                            : t(cartValues["ControlPositionB"]));
                      }
                    } else if (
                      key === "PrivacyLayerHardware" &&
                      cartValues["PrivacyLayerHardware"] !== "None"
                    ) {
                      if (cartValues["RailDesignEnC"] === "Motorized Track") {
                        objLabel =
                          t(cartValues[key].toString()) +
                          " / " +
                          (pageLanguage === "fa"
                            ? cartValues["RailDesignFaC"]
                            : cartValues["RailDesignEnC"]);
                      } else {
                        objLabel =
                          t(cartValues[key].toString()) +
                          " / " +
                          (pageLanguage === "fa"
                            ? cartValues["RailDesignFaC"]
                            : cartValues["RailDesignEnC"]) +
                          " \n " +
                          (pageLanguage === "fa"
                            ? cartValues["RailColorFaC"]
                            : cartValues["RailColorEnC"]) +
                          " / " +
                          (cartValues["BatonOptionC"]
                            ? t(cartValues["BatonOptionC"])
                            : t(cartValues["ControlPositionC"]));
                      }
                    } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                      objLabel =
                        t("agree_Qty") + NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                    } else if (key === "HandCurtainEn2" || key === "HandCurtainFa2") {
                      objLabel =
                        t("agree_Qty") + NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                    } else if (tempObj["titleValue"] === null || true) {
                      if (tempObj["titlePostfix"] === "") {
                        console.log(key, ",", cartValues[key]);
                        objLabel =
                          pageLanguage === "fa"
                            ? NumberToPersianWord.convertEnToPe(
                                `${t(cartValues[key].toString())}`
                              ).toString()
                            : t(cartValues[key].toString());
                      } else {
                        objLabel =
                          pageLanguage === "fa"
                            ? NumberToPersianWord.convertEnToPe(`${cartValues[key]}`).toString() +
                              t(tempObj["titlePostfix"])
                            : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                      }
                      // objLabel = cartValues[key].toString() + tempObj["titlePostfix"];
                    } else {
                      // console.log(tempObj["titleValue"],tempObj["titleValue"][cartValues[key].toString()],cartValues[key]);
                      if (tempObj["titleValue"][cartValues[key].toString()] === null) {
                        if (tempObj["titlePostfix"] === "") {
                          objLabel = t(cartValues[key].toString());
                        } else {
                          objLabel =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${cartValues[key]}`).toString() +
                                t(tempObj["titlePostfix"])
                              : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                        }
                      } else {
                        objLabel = t(tempObj["titleValue"][cartValues[key].toString()]);
                      }
                    }
                    if (tempObj["fabric"] === undefined) {
                      temp5[tempObj["order"]] = (
                        <li className="cart_agree_item" key={key}>
                          <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                        </li>
                      );
                      resolve();
                    } else if (tempObj["fabric"] === 1) {
                      temp1[tempObj["order"]] = (
                        <li className="cart_agree_item" key={key}>
                          <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                        </li>
                      );
                      resolve();
                    } else if (tempObj["fabric"] === 2) {
                      temp2[tempObj["order"]] = (
                        <li className="cart_agree_item" key={key}>
                          <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                        </li>
                      );
                      resolve();
                    } else if (tempObj["fabric"] === 3) {
                      temp3[tempObj["order"]] = (
                        <li className="cart_agree_item" key={key}>
                          <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                        </li>
                      );
                      resolve();
                    } else {
                      resolve();
                    }
                  } else {
                    resolve();
                  }
                }
              });
            });

            Promise.all([...promiseArr, ...promiseArr2]).then(() => {
              tempArr.push(
                <div key={defaultModelName}>
                  <h2 className="cart_agree_title">
                    {pageLanguage === "fa"
                      ? convertToPersian(defaultModelNameFa) + " سفارشی "
                      : "Custom " + defaultModelName}
                  </h2>
                  <ul className="cart_agree_items_container">
                    <GetMeasurementArray
                      modelId={`${cartValues["SewingModelId"]}`}
                      cartValues={cartValues}
                    />
                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                      <h1 className="cart_agree_item_fabrics_sorted_title 4">
                        {t("General Details")}
                      </h1>
                      <ul>{temp5}</ul>
                    </li>
                    {SewingModelId === "0099" && (
                      <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                        <h1 className="cart_agree_item_fabrics_sorted_title">{t("Drapery")}</h1>
                        <ul>
                          <li className="cart_agree_item">
                            <h1 className="cart_agree_item_title">{t("Material & Color")}&nbsp;</h1>
                            <h2 className="cart_agree_item_desc">
                              {pageLanguage === "fa"
                                ? cartValues["FabricDesignFa"] + " / " + cartValues["FabricColorFa"]
                                : CapitalizeAllWords(
                                    cartValues["FabricDesignEn"] +
                                      " / " +
                                      cartValues["FabricColorEn"]
                                  )}
                            </h2>
                          </li>
                          {cartValues["BorderOrTrimId"] && cartValues["borderPosition"] && (
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Decorative Border")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["BorderOrTrimDesignFa"] +
                                    " / " +
                                    cartValues["BorderOrTrimColorFa"] +
                                    " \n " +
                                    t(cartValues["borderPosition"])
                                  : CapitalizeAllWords(
                                      cartValues["BorderOrTrimDesignEn"] +
                                        " / " +
                                        cartValues["BorderOrTrimColorEn"] +
                                        " \n " +
                                        t(cartValues["borderPosition"])
                                    )}
                              </h2>
                            </li>
                          )}
                          {cartValues["BorderOrTrimId"] && !cartValues["borderPosition"] && (
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Decorative Trim")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["BorderOrTrimDesignFa"] +
                                    " / " +
                                    cartValues["BorderOrTrimColorFa"]
                                  : CapitalizeAllWords(
                                      cartValues["BorderOrTrimDesignEn"] +
                                        " / " +
                                        cartValues["BorderOrTrimColorEn"]
                                    )}
                              </h2>
                            </li>
                          )}
                          {temp1}
                        </ul>
                      </li>
                    )}
                    {SewingModelId === "0099" && (
                      <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                        <h1 className="cart_agree_item_fabrics_sorted_title">{t("Sheer")}</h1>
                        <ul>
                          <li className="cart_agree_item">
                            <h1 className="cart_agree_item_title">{t("Material & Color")}&nbsp;</h1>
                            <h2 className="cart_agree_item_desc">
                              {pageLanguage === "fa"
                                ? cartValues["FabricDesignFa2"] +
                                  " / " +
                                  cartValues["FabricColorFa2"]
                                : CapitalizeAllWords(
                                    cartValues["FabricDesignEn2"] +
                                      " / " +
                                      cartValues["FabricColorEn2"]
                                  )}
                            </h2>
                          </li>
                          {cartValues["BorderOrTrimId2"] && cartValues["borderPosition2"] && (
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Decorative Border")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["BorderOrTrimDesignFa2"] +
                                    " / " +
                                    cartValues["BorderOrTrimColorFa2"] +
                                    " \n " +
                                    t(cartValues["borderPosition2"])
                                  : CapitalizeAllWords(
                                      cartValues["BorderOrTrimDesignEn2"] +
                                        " / " +
                                        cartValues["BorderOrTrimColorEn2"] +
                                        " \n " +
                                        t(cartValues["borderPosition2"])
                                    )}
                              </h2>
                            </li>
                          )}
                          {cartValues["BorderOrTrimId2"] && !cartValues["borderPosition2"] && (
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Decorative Trim")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["BorderOrTrimDesignFa2"] +
                                    " / " +
                                    cartValues["BorderOrTrimColorFa2"]
                                  : CapitalizeAllWords(
                                      cartValues["BorderOrTrimDesignEn2"] +
                                        " / " +
                                        cartValues["BorderOrTrimColorEn2"]
                                    )}
                              </h2>
                            </li>
                          )}
                          {temp2}
                        </ul>
                      </li>
                    )}
                    {SewingModelId === "0099" &&
                      cartValues["PrivacyLayer"] !== "none" &&
                      cartValues["SheersDesignEn"] &&
                      cartValues["SheersColorEn"] && (
                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                          <h1 className="cart_agree_item_fabrics_sorted_title">
                            {t("Privacy Layer")}
                          </h1>
                          <ul>
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Material & Color")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["SheersDesignFa"] +
                                    " / " +
                                    cartValues["SheersColorFa"]
                                  : CapitalizeAllWords(
                                      cartValues["SheersDesignEn"] +
                                        " / " +
                                        cartValues["SheersColorEn"]
                                    )}
                              </h2>
                            </li>
                            {temp3}
                          </ul>
                        </li>
                      )}
                    {SewingModelId === "0321" && (
                      <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                        <h1 className="cart_agree_item_fabrics_sorted_title">{t("Drapery")}</h1>
                        <ul>
                          <li className="cart_agree_item">
                            <h1 className="cart_agree_item_title">{t("Material & Color")}&nbsp;</h1>
                            <h2 className="cart_agree_item_desc">
                              {pageLanguage === "fa"
                                ? cartValues["FabricDesignFa"] + " / " + cartValues["FabricColorFa"]
                                : CapitalizeAllWords(
                                    cartValues["FabricDesignEn"] +
                                      " / " +
                                      cartValues["FabricColorEn"]
                                  )}
                            </h2>
                          </li>
                          {cartValues["BorderOrTrimId"] && cartValues["borderPosition"] && (
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Decorative Border")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["BorderOrTrimDesignFa"] +
                                    " / " +
                                    cartValues["BorderOrTrimColorFa"] +
                                    " \n " +
                                    t(cartValues["borderPosition"])
                                  : CapitalizeAllWords(
                                      cartValues["BorderOrTrimDesignEn"] +
                                        " / " +
                                        cartValues["BorderOrTrimColorEn"] +
                                        " \n " +
                                        t(cartValues["borderPosition"])
                                    )}
                              </h2>
                            </li>
                          )}
                          {cartValues["BorderOrTrimId"] && !cartValues["borderPosition"] && (
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Decorative Trim")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["BorderOrTrimDesignFa"] +
                                    " / " +
                                    cartValues["BorderOrTrimColorFa"]
                                  : CapitalizeAllWords(
                                      cartValues["BorderOrTrimDesignEn"] +
                                        " / " +
                                        cartValues["BorderOrTrimColorEn"]
                                    )}
                              </h2>
                            </li>
                          )}
                          {temp1}
                        </ul>
                      </li>
                    )}
                    {SewingModelId === "0321" && (
                      <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                        <h1 className="cart_agree_item_fabrics_sorted_title">{t("Sheer")}</h1>
                        <ul>
                          <li className="cart_agree_item">
                            <h1 className="cart_agree_item_title">{t("Material & Color")}&nbsp;</h1>
                            <h2 className="cart_agree_item_desc">
                              {pageLanguage === "fa"
                                ? cartValues["FabricDesignFa2"] +
                                  " / " +
                                  cartValues["FabricColorFa2"]
                                : CapitalizeAllWords(
                                    cartValues["FabricDesignEn2"] +
                                      " / " +
                                      cartValues["FabricColorEn2"]
                                  )}
                            </h2>
                          </li>
                          {cartValues["BorderOrTrimId2"] && cartValues["borderPosition2"] && (
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Decorative Border")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["BorderOrTrimDesignFa2"] +
                                    " / " +
                                    cartValues["BorderOrTrimColorFa2"] +
                                    " \n " +
                                    t(cartValues["borderPosition2"])
                                  : CapitalizeAllWords(
                                      cartValues["BorderOrTrimDesignEn2"] +
                                        " / " +
                                        cartValues["BorderOrTrimColorEn2"] +
                                        " \n " +
                                        t(cartValues["borderPosition2"])
                                    )}
                              </h2>
                            </li>
                          )}
                          {cartValues["BorderOrTrimId2"] && !cartValues["borderPosition2"] && (
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Decorative Trim")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["BorderOrTrimDesignFa2"] +
                                    " / " +
                                    cartValues["BorderOrTrimColorFa2"]
                                  : CapitalizeAllWords(
                                      cartValues["BorderOrTrimDesignEn2"] +
                                        " / " +
                                        cartValues["BorderOrTrimColorEn2"]
                                    )}
                              </h2>
                            </li>
                          )}
                          {temp2}
                        </ul>
                      </li>
                    )}
                    {SewingModelId === "0321" &&
                      cartValues["PrivacyLayer"] !== "none" &&
                      cartValues["SheersDesignEn"] &&
                      cartValues["SheersColorEn"] && (
                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                          <h1 className="cart_agree_item_fabrics_sorted_title">
                            {t("Privacy Layer")}
                          </h1>
                          <ul>
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Material & Color")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["SheersDesignFa"] +
                                    " / " +
                                    cartValues["SheersColorFa"]
                                  : CapitalizeAllWords(
                                      cartValues["SheersDesignEn"] +
                                        " / " +
                                        cartValues["SheersColorEn"]
                                    )}
                              </h2>
                            </li>
                            {temp3}
                          </ul>
                        </li>
                      )}
                    {!!temp4.length && (
                      <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                        <h1 className="cart_agree_item_fabrics_sorted_title">{t("Accessories")}</h1>
                        <ul>{temp4}</ul>
                      </li>
                    )}
                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_label">
                      <h1 className="cart_agree_item_title">
                        {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}&nbsp;
                      </h1>
                      <h2 className="cart_agree_item_desc">
                        {pageLanguage === "fa"
                          ? roomNameFa + (WindowName === "" ? "" : " / " + WindowName)
                          : roomName + (WindowName === "" ? "" : " / " + WindowName)}
                      </h2>
                    </li>
                    {moreInfoInput !== "" && (
                      <li className="cart_agree_item">
                        <h1 className="cart_agree_item_title">{t("Order Notes")}&nbsp;</h1>
                        <ShowMoreLineLimited moreInfoInput={moreInfoInput} lines={3} />
                      </li>
                    )}
                    <li className="cart_agree_item">
                      <h1 className="cart_agree_item_title">{t("Price")}&nbsp;</h1>
                      <h2 className="cart_agree_item_desc">
                        {GetPrice(tempBagPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                      </h2>
                    </li>
                  </ul>
                </div>
              );
              setCartAgree(tempArr);
              modalHandleShow("cart_modal");
              projectsButtonRef.current[index].disabled = false;
              projectsButtonRef.current[index].innerHTML = t("ADD TO BAG");
            });
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  addProjectToBag(projectObj, index);
                } else {
                  projectsButtonRef.current[index].disabled = false;
                  projectsButtonRef.current[index].innerHTML = t("ADD TO BAG");
                  navigate("/en" + "/User");
                }
              });
            } else {
              projectsButtonRef.current[index].disabled = false;
              projectsButtonRef.current[index].innerHTML = t("ADD TO BAG");
              console.log("project not added");
              modalHandleClose("cart_modal");
            }
          });
      } else {
        projectsButtonRef.current[index].disabled = false;
        projectsButtonRef.current[index].innerHTML = t("ADD TO BAG");
      }
    });
  }

  function addToCart_agreed(projectObj) {
    GetUserProjectData(projectObj, true).then((temp) => {
      console.log(`temp`, temp);
      AddProjectToCart(
        temp,
        projectObj["PreorderText"]["SewingModelId"],
        projectObj["Price"],
        temp["ModelNameEn"],
        temp["ModelNameFa"],
        [
          temp["uploadedImagesFile"] ? temp["uploadedImagesFile"] : [],
          temp["uploadedImagesURL"] ? temp["uploadedImagesURL"] : [],
          temp["uploadedPDFFile"] ? temp["uploadedPDFFile"] : [],
          temp["uploadedPDFURL"] ? temp["uploadedPDFURL"] : [],
        ],
        projectObj["SewingOrderId"],
        undefined,
        navigate,
        true
        //  temp["Accessories"][0]
      ).then((temp2) => {
        if (temp2 === 401) {
          addToCart_agreed(projectObj);
        } else if (temp2) {
          setCartAgreeDescription(false);
          renderCart(temp2);

          dispatch({
            type: CartUpdatedTrue,
            payload: { mainCart: temp2 },
          });

          setTimeout(() => {
            // modalHandleShow("cart_modal");
            setCartStateAgree(true);
          }, 500);
          setAddingLoading(false);
        } else {
          setAddingLoading(false);
          setCartAgreeDescription(false);
        }
      });
    });
  }

  function renderCart(customPageCart) {
    let cartObjects = {};
    let promise2 = new Promise((resolve, reject) => {
      if (customPageCart !== undefined) {
        cartObjects = customPageCart;
        resolve();
      } else {
        // if (isLoggedIn) {
        axios
          .get(baseURLGetCart, {
            headers: authHeader(),
          })
          .then((response) => {
            cartObjects = response.data ? response.data : {};
            resolve();
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  renderCart(customPageCart);
                } else {
                  navigate("/" + pageLanguage + "/User");
                }
              });
            } else {
              modalHandleClose("cart_modal");
              reject();
            }
          });
      }
    });
    promise2.then(() => {
      let cartCount = 0;
      let totalPrice = 0;
      setSideCartObjects(cartObjects);
      // if (isLoggedIn) {
      if (cartObjects["CartDetails"].length === 0) {
        modalHandleClose("cart_modal");
        setCartStateAgree(false);
      }
      cartCount += cartObjects["CartDetails"].length;

      setCartCount(cartCount);
    });
    axios
      .get(baseURLFreeShipping)
      .then((response) => {
        setFreeShipPrice(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (cartUpdated) {
      setCartCount(mainCart["CartDetails"]?.length || 0);
    }
  }, [cartUpdated]);

  function CustomDropdownFiles({ props, state, methods }) {
    const regexp = new RegExp(state.search, "i");

    return (
      <div className={props.className}>
        <div className="select_item_container">
          {props.options
            .filter((item) => regexp.test(item[props.searchBy] || item[props.labelField]))
            .map((option) => {
              let exist = "false";
              let extensionSearch = /(?:\.([^.]+))?$/;
              let extension = extensionSearch.exec(option[props.labelField])[1].toLowerCase();
              let fileName = option[props.labelField].replace(/\.[^/.]+$/, "");

              return (
                <div
                  className="select_item uploaded_name_item"
                  item-selected={exist}
                  disabled={option.disabled}
                  key={option[props.valueField]}
                >
                  <i className="fa fa-file" />
                  <div
                    className="uploaded_name_item_text"
                    onClick={() => showFile(`${option[props.valueField]}`, extension)}
                  >
                    {fileName}
                  </div>
                  <div
                    className="uploaded_name_item_x"
                    onClick={() => {
                      deleteUploaded(option[props.valueField]);
                      methods.addItem(option);
                    }}
                  >
                    X
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  let imageExtensionList = ["jpg", "png", "jpeg", "jiff", "gif", "webp"];
  let pdfExtensionList = ["pdf"];

  function showFile(fileUrl, extension) {
    if (imageExtensionList.indexOf(extension) > -1) {
      handleShow(fileUrl);
    } else if (pdfExtensionList.indexOf(extension) > -1) {
      const pdfWindow = window.open();
      pdfWindow.location.href = imgUrl(fileUrl);
    }
  }

  function deleteUploaded(fileUrl) {
    let promise2 = new Promise((resolve, reject) => {
      if (fileUrl !== "") {
        axios
          .delete(baseURLDeleteFile, {
            params: {
              url: fileUrl,
            },
            headers: authHeader(),
          })
          .then((response) => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  deleteUploaded(fileUrl);
                  reject();
                } else {
                  resolve();
                }
              });
            } else {
              resolve();
            }
          });
      } else {
        resolve();
      }
    });
    promise2.then(() => {});
  }

  function deleteFileFromProject(obj, projectId) {
    let temp = JSON.parse(JSON.stringify(userProjects));
    let tempProject = temp.find((opt) => opt["SewingOrderId"] === projectId);
    let tempFileIndex = tempProject["SewingOrderAttachments"].findIndex(
      (opt) => opt["FileUrl"] === obj.value
    );

    tempProject["SewingOrderAttachments"].splice(tempFileIndex, 1);

    tempProject["Count"] = tempProject["WindowCount"];
    editProject(tempProject);
  }

  function handleShow(PhotoPath) {
    const tempDiv = [];
    // const tempDiv1 = [];
    tempDiv.push(
      <div key={PhotoPath} className="zoomImg">
        <div className="imageContainer">
          <object className="img-fluid intractable" data={imgUrl(PhotoPath)} />
        </div>
      </div>
    );

    setZoomModalBody(tempDiv);
    setShow(true);
  }

  useEffect(() => {
    if (userProjects.length) {
      renderUserProjects();
    } else if (!firstFetch) {
      setUserProjectsRender([
        <h1 key={1} className="no_project">
          You don't have any saved project yet.
        </h1>,
      ]);
    } else {
    }
  }, [userProjects]);

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
    getUserProjects();
  }, [location.pathname]);

  return (
    <div
      className={`basket_page_container Project_page_container ${
        pageLanguage === "fa" ? "font_farsi" : "font_en"
      }`}
    >
      <h1 className="Account_settings_section_title">{t("MY PROJECTS")}</h1>
      <div className="basket_container Projects_container">
        <div className="basket_flex">
          <div className="basket_section">
            <div className="drapery_basket">
              <div className="drapery_basket_header basket_header desktop_only">
                <span className="basket_header_title">{t("PROJECT DETAILS")}</span>
                <span className="basket_header_price">{t("PRICE")}</span>
                <span className="basket_header_qty">{t("QTY")}</span>
                <span className="basket_header_total">{t("TOTAL PRICE")}</span>
              </div>
              <ul className="drapery_basket_items">{userProjectsRender}</ul>
            </div>
          </div>
        </div>
      </div>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["cart_modal"] === undefined ? false : modals["cart_modal"]}
        onHide={() => {
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }}
        id="cart_modal"
      >
        {cartStateAgree && (
          <div className="custom_cart_header_desc">{`${
            freeShipPrice - sideCartPrice > 0
              ? `${t("cart_agree_free_ship1")}${
                  pageLanguage === "fa"
                    ? NumberToPersianWord.convertEnToPe(
                        `${GetPrice(
                          freeShipPrice - sideCartPrice,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}`
                      )
                    : GetPrice(
                        freeShipPrice - sideCartPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )
                }${t("cart_agree_free_ship2")}`
              : `${t("cart_agree_free_ship")}`
          }`}</div>
        )}
        <Modal.Header>
          {cartStateAgree && (
            <span className="custom_cart_title">
              {t("My Bag")}{" "}
              <h3>
                (
                {pageLanguage === "fa"
                  ? NumberToPersianWord.convertEnToPe(`${cartCount}`)
                  : cartCount}
                )
              </h3>
            </span>
          )}
          {!cartStateAgree && <p className="custom_cart_title">&nbsp;</p>}
          <button
            className="custom_cart_close"
            onClick={() => {
              modalHandleClose("cart_modal");
              setCartStateAgree(false);
              setAddingLoading(false);
              sessionStorage.clear();
              if (cartStateAgree) {
                navigate("/" + pageLanguage);
              }
            }}
          >
            {t("CONTINUE SHOPPING")}
          </button>
        </Modal.Header>
        <Modal.Body>
          {cartStateAgree && <RenderSideCart cartObjects={sideCartObjects} />}

          {!cartStateAgree && <h1 className="cart_agree_title1">{t("REVIEW ORDER")}</h1>}
          {!cartStateAgree && <h2 className="cart_agree_title2">{t("TERMS OF SALE")}</h2>}
          {!cartStateAgree && <div>{cartAgree}</div>}
          {!cartStateAgree && (
            <span className="cart_agree_desc">
              <label className="checkbox_style">
                <input
                  type="checkbox"
                  checked={cartAgreeDescription}
                  onChange={(e) => {
                    setCartAgreeDescription(e.target.checked);
                  }}
                  id="cartAgreeDescription"
                />
                <label htmlFor="cartAgreeDescription" className="checkbox_label">
                  <img
                    className="checkbox_label_img checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1_checkbox.png")}
                    alt=""
                  />
                </label>
                <span className="checkbox_text">
                  {t("cart_agree_desc")}
                  <p className="return_policy">
                    {t("See Return Policy1")}
                    <Link className="link_between_text" to={"/" + pageLanguage}>
                      {t("See Return Policy2")}
                    </Link>
                    {t("See Return Policy3")}
                  </p>
                  .
                </span>
              </label>
            </span>
          )}
          {!cartStateAgree && (
            <div className="go_to_checkout">
              <button
                className="basket_checkout"
                onClick={() => {
                  setAddingLoading(true);
                  addToCart_agreed(bagProjectObject);
                }}
                disabled={addingLoading || !cartAgreeDescription}
              >
                {addingLoading ? t("ADDING...") : t("AGREE & ADD TO BAG")}
              </button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {cartStateAgree && (
            <div className="go_to_checkout">
              <div className="checkout_button_section small_checkout_button_section">
                <span className="checkout_payment_price_detail payment_price_detail">
                  <h3>{t("SUBTOTAL")}</h3>
                  <h4>{GetPrice(sideCartPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}</h4>
                </span>
                <Link
                  className="basket_checkout btn"
                  to={"/" + pageLanguage + "/Basket"}
                  onClick={() => {
                    setCartStateAgree(false);
                  }}
                >
                  {t("CHECKOUT")}
                </Link>
              </div>
            </div>
          )}
        </Modal.Footer>
      </Modal>
      <Modal dialogClassName="zoomModal" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>{zoomModalHeaderRef.current}</Modal.Header>
        <Modal.Body>{zoomModalBody}</Modal.Body>
        <Modal.Footer>
          <button className=" btn btn-new-dark" onClick={() => setShow(false)}>
            {t("CONTINUE")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Projects;
